var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "recharge-form",
          attrs: {
            model: _vm.newFormInline,
            rules: _vm.formRule,
            "label-position": "top",
            "label-width": "120px",
            size: "small",
          },
        },
        [
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _vm._v(_vm._s(_vm.$t("basicData.PayerInformation"))),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "CNPJ", prop: "cnpj" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("basicData.PleaseEnterCNPJ"),
                              clearable: "",
                            },
                            on: {
                              blur: _vm.onCnpjBlur,
                              input: _vm.onCnpjInput,
                            },
                            model: {
                              value: _vm.newFormInline.cnpj,
                              callback: function ($$v) {
                                _vm.$set(_vm.newFormInline, "cnpj", $$v)
                              },
                              expression: "newFormInline.cnpj",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.CustomerName"),
                            prop: "customerId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: !_vm.customerOptions.length,
                                placeholder: _vm.$t(
                                  "basicData.PleaseSelectCustomer"
                                ),
                              },
                              on: { change: _vm.handleCustomerChange },
                              model: {
                                value: _vm.newFormInline.customerId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newFormInline, "customerId", $$v)
                                },
                                expression: "newFormInline.customerId",
                              },
                            },
                            _vm._l(_vm.customerOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.username, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.TopUpAmount"),
                            prop: "amount",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "basicData.PleaseEnterAmount"
                              ),
                            },
                            model: {
                              value: _vm.newFormInline.amount,
                              callback: function ($$v) {
                                _vm.$set(_vm.newFormInline, "amount", $$v)
                              },
                              expression: "newFormInline.amount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.RechargeDate"),
                            prop: "rechargeDate",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "basicData.PleaseSelectRechargeDate"
                              ),
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.newFormInline.rechargeDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.newFormInline, "rechargeDate", $$v)
                              },
                              expression: "newFormInline.rechargeDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.SerialNumber"),
                            prop: "serialNumber",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "basicData.PleaseEnterBankSerialNumber"
                              ),
                            },
                            model: {
                              value: _vm.newFormInline.serialNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.newFormInline, "serialNumber", $$v)
                              },
                              expression: "newFormInline.serialNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _vm._v(_vm._s(_vm.$t("basicData.PayeeInformation"))),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 32 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.ReceivingAccount"),
                            prop: "bankAccountId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "basicData.PleaseSelectReceivingAccount"
                                ),
                              },
                              model: {
                                value: _vm.newFormInline.bankAccountId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.newFormInline,
                                    "bankAccountId",
                                    $$v
                                  )
                                },
                                expression: "newFormInline.bankAccountId",
                              },
                            },
                            _vm._l(_vm.bankAccountOptions, function (item) {
                              return _c("el-option", {
                                key: item.accountNumber,
                                attrs: {
                                  label: item.companyName,
                                  value: item.accountNumber,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _vm._v(" " + _vm._s(_vm.$t("basicData.annex")) + " "),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 32 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "receiptFile" } },
                        [
                          _c("UploadCmp", {
                            ref: "uploadCmp",
                            attrs: {
                              "auto-upload": true,
                              drag: true,
                              "file-size": 5,
                              "file-type": _vm.fileType,
                              "is-check-file-type": true,
                              limit: 1,
                              "show-file-list": true,
                              tips: _vm.$t(
                                "basicData.UploadTheAttachmentFormat"
                              ),
                              "upload-text": _vm.$t(
                                "basicData.UploadBankReceipt"
                              ),
                            },
                            on: { change: _vm.handleUploadSuccess },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "el-form-footer" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
          ),
          _c(
            "el-button",
            {
              staticStyle: { margin: "0" },
              attrs: { loading: _vm.loading, size: "small", type: "primary" },
              on: { click: _vm.save },
            },
            [_vm._v(_vm._s(_vm.$t("basicData.Save")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }